const PREFIX = 'STATION/';

export const SET_VIDEO = `${PREFIX}SET_VIDEO`;

export const SET_SELECTED_STATION = `${PREFIX}SET_SELECTED_STATION`;
export const SET_STATIONS = `${PREFIX}SET_STATIONS`;
export const RESET_STATIONS = `${PREFIX}RESET_STATIONS`;

export const SET_VISITED_STATION = `${PREFIX}SET_VISITED_STATION`;
export const VISIT_ALL_STATIONS = `${PREFIX}VISIT_ALL_STATIONS`;
export const RESET_VISITED_STATUS_ALL_STATIONS = `${PREFIX}RESET_VISITED_STATUS_ALL_STATIONS`;
